import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentAdministrationProcedures(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentAdministrationProcedures.url, {
        id: enrollmentId
      })
    )
    .get<{ content: string }>()
}

export function getEnrollmentCanAccessAdministrationProcedures(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentCanAccessAdministrationProcedures.url, {
        id: enrollmentId
      })
    )
    .get<boolean>()
}
